import { ReactElement, useCallback } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { VisitCancelNotConfirmedModal } from './VisitCancelNotConfirmedModal';

type VisitCancelNotConfirmedModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type VisitCancelNotConfirmedModalOpenerProps = {
   appointmentId: number;
   onSuccess?: VoidFunction;
   children: (renderProps: VisitCancelNotConfirmedModalOpenerChildrenRenderProps) => ReactElement;
};

export const VisitCancelNotConfirmedModalOpener = (props: VisitCancelNotConfirmedModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   const { onSuccess } = props;

   const handleSuccess = useCallback(() => {
      onSuccess?.();
      closeModal();
   }, [closeModal, onSuccess]);

   return (
      <>
         {modalOpened ? (
            <VisitCancelNotConfirmedModal
               appointmentId={props.appointmentId}
               onSuccess={handleSuccess}
               onClose={closeModal}
            />
         ) : null}
         {props.children({ openModal: openModal })}
      </>
   );
};
